export default {
    data: () => ({
        translations: {
            title: {
                el: "Οδηγίες Χρήσης",
                en: "User Manual",
                it: "Istruzioni per l'uso"
            },
            info: {
                el: "Ανέβασε τις οδηγίες χρήσης που θα βλέπει η κάθε επιχείρηση (σε μορφή pdf). Eπιλέξτε το αρχείο pdf και μετά πατήστε αποθήκευση.",
                en: `
                    Upload user manual that every business will see (in .pdf format). Select
                    pdf file and then click save.
                `,
                it: "Carica le istruzioni per l'uso che ogni azienda vedrà (in formato pdf). Seleziona il file pdf e poi clicca su salva."
            },
            uploadText: {
                el: "Επιλέξτε αρχείο pdf :",
                en: "Choose pdf file:",
                it: "Seleziona il file pdf:"
            }
        }
    })
};
